import React from 'react';
import { Container } from '../Container';
import { Label } from '../Label';
import { Button } from '../Button';
import { Reveal } from '../Reveal';
export function InfluencerCTA() {
  return <section className="py-[clamp(70px,10vw,140px)]" id="apply" data-id="element-94" data-mp="19rjhys44v2x9">
      <Container data-id="element-95" data-mp="19u5nkm7gr8cu">
        <Label data-id="element-96" data-mp="14syg6o98gb6p">04 · Two ways in</Label>
        <div className="mt-[clamp(32px,5vw,64px)] grid grid-cols-2 gap-px border-t border-brand-gray300 bg-brand-gray300 max-[820px]:grid-cols-1" data-id="element-97" data-mp="14rwuzqyi68b9">
          <Reveal className="h-full" data-id="element-98" data-mp="zvpyspvwsb6i">
            <div className="flex h-full flex-col bg-brand-white p-[clamp(32px,4vw,56px)]" data-id="element-99" data-mp="v2wpdophweo3">
              <h2 className="text-[clamp(2rem,4vw,3.4rem)] font-black uppercase leading-[0.95] tracking-[-0.035em]" data-id="element-100" data-mp="q3k2j3ymj7li">
                For influencers
              </h2>
              <p className="mt-5 max-w-[42ch] text-[clamp(15px,1.2vw,18px)] leading-[1.5] text-[#2a2a2a]" data-id="element-101" data-mp="m0nl3gktlhj5">
                Looking for representation? Tell us about your audience, your
                goals, and what you want the next two years to look like.
              </p>
              <div className="mt-auto pt-10" data-id="element-102" data-mp="2u9ky2vuf2nmv">
                <Button href="/contact" variant="solid" data-id="element-103" data-mp="2z24c1tx0nks7">
                  Apply for representation
                </Button>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="h-full" data-id="element-104" data-mp="2q9ah6o536ct8">
            <div className="flex h-full flex-col bg-brand-white p-[clamp(32px,4vw,56px)]" data-id="element-105" data-mp="2qa29nq3dzufa">
              <h2 className="text-[clamp(2rem,4vw,3.4rem)] font-black uppercase leading-[0.95] tracking-[-0.035em]" data-id="element-106" data-mp="3e06fm441s69g">
                For brands
              </h2>
              <p className="mt-5 max-w-[42ch] text-[clamp(15px,1.2vw,18px)] leading-[1.5] text-[#2a2a2a]" data-id="element-107" data-mp="340xnlgsqt1pq">
                Want to work with Abie-managed talent? Bring us the brief and
                we'll build the partnership around it.
              </p>
              <div className="mt-auto pt-10" data-id="element-108" data-mp="1sk7ffs4rdzth">
                <Button href="/contact" variant="outline" data-id="element-109" data-mp="1xl4v9y2aqhrt">
                  Partner with us
                </Button>
              </div>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>;
}